import script from "./ValidacaoSucesso.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidacaoSucesso.vue?vue&type=script&setup=true&lang=js"

import "./ValidacaoSucesso.vue?vue&type=style&index=0&id=2ace9510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ace9510"]])

export default __exports__